<!--
  @author  yuanchaoxi<ycx@sxw.cn>
  @date    2020/3/5
  @description  AntForm组件
-->
<template>
  <a-form :form="form" :layout="formLayout">
    <a-row :gutter="24">
      <a-col
        v-for="formItem in formItemConfig"
        :key="formItem.decoratorKey"
        :data-debug="formItem.decoratorKey"
        :span="formLayout === 'horizontal' ? 24 : 4 * (formItem.colSpan || 1)"
      >
        <a-form-item
          :style="{
            width: '100%',
            height: formLayout === 'inline' ? '50px' : 'auto'
          }"
          :label="formItem.label"
          :labelCol="{ span: formLayout === 'horizontal' ? 6 : 0 }"
          :wrapperCol="{ span: formLayout === 'horizontal' ? 16 : 24 }"
          :required="!!formItem.required"
        >
          <a-input
            v-if="formItem.type === 'input'"
            style="width: 100%"
            :disabled="formItem.disabled"
            size="large"
            :placeholder="formItem.placeholder || '请输入'"
            v-decorator="[
              formItem.decoratorKey,
              { validateTrigger: 'blur', rules: formItem.rules }
            ]"
          />

          <a-input-number
            v-if="formItem.type === 'inputNumber'"
            style="width: 100%"
            :disabled="formItem.disabled"
            size="large"
            :placeholder="formItem.placeholder || '请输入'"
            v-decorator="[
              formItem.decoratorKey,
              { validateTrigger: 'blur', rules: formItem.rules }
            ]"
          />

          <a-select
            v-if="formItem.type === 'select'"
            style="width: 100%"
            size="large"
            :allowClear="!formItem.disableClear"
            :placeholder="formItem.placeholder || '请选择'"
            v-decorator="[formItem.decoratorKey, { rules: formItem.rules }]"
          >
            <a-select-option
              v-for="optionItem in formItem.selectOptions"
              :key="optionItem.value"
              :value="optionItem.value"
              >{{ optionItem.label }}</a-select-option
            >
          </a-select>

          <a-date-picker
            v-if="formItem.type === 'datepicker'"
            style="width: 100%"
            size="large"
            :placeholder="formItem.placeholder || '请选择'"
            v-decorator="[formItem.decoratorKey, { rules: formItem.rules }]"
          />

          <a-month-picker
            v-if="formItem.type === 'monthpicker'"
            size="large"
            placeholder="请选择"
            v-decorator="[formItem.decoratorKey, { rules: formItem.rules }]"
          />

          <a-range-picker
            v-if="formItem.type === 'monthpickerRange'"
            :mode="['month', 'month']"
            @panelChange="monthpickerRangeChange($event, formItem)"
            format="YYYY-MM"
            style="width: 100%"
            size="large"
            :placeholder="formItem.placeholder || ['请选择', '请选择']"
            v-decorator="[formItem.decoratorKey, { rules: formItem.rules }]"
          />

          <a-range-picker
            v-if="formItem.type === 'datepickerRange'"
            style="width: 100%"
            size="large"
            :placeholder="formItem.placeholder || ['请选择', '请选择']"
            v-decorator="[formItem.decoratorKey, { rules: formItem.rules }]"
          />

          <a-textarea
            v-if="formItem.type === 'textarea'"
            style="width: 100%"
            size="large"
            :placeholder="formItem.placeholder || '请输入'"
            :autosize="{ minRows: 4 }"
            v-decorator="[formItem.decoratorKey, { rules: formItem.rules }]"
          />
        </a-form-item>
      </a-col>
      <slot />
    </a-row>
  </a-form>
</template>

<script>
export default {
  mixins: [],
  components: {},
  data() {
    return {
      form: this.$form.createForm(this, {
        onValuesChange: this.onValuesChange
      }),
      // 表单内表项的布局方式
      formLayout: 'horizontal',

      // 弹窗显影 由外部控制
      visible: false,
      // 弹窗标题 由外部控制
      titleName: '弹窗标题未设置',

      // 表项配置项
      formItemConfig: []
    };
  },
  created() {},

  methods: {
    monthpickerRangeChange(val, formItem) {
      console.log(111, val, formItem);
      let data = {};
      data[formItem.decoratorKey] = val;
      // 设置值
      this.setFieldsValue(data);
    },
    /**
     * 值变更的事件
     */
    onValuesChange(props, values) {
      // console.log('值变更',props, values);
      this.$emit('valChange', this.titleName, values);
    },
    /**
     * 设置表单域
     * @param config
     * @param config[].label
     * @param config[].placeholder {string|array} 时间范围选择组件需传递数组字符串
     * @param config[].type
     * @param config[].decoratorKey
     * @param config[].required
     * @param config[].rules
     * @param config[].colSpan
     * @param config[].selectOptions
     */
    setFormItemConfig(config) {
      config = config || [
        {
          label: 'input输入',
          type: 'input',
          decoratorKey: 'name',
          required: true, // 是否必填
          rules: [{ required: true, message: '不能为空' }], // 表单的校验规则
          colSpan: 1,
          selectOptions: '下拉选项，当且仅当表单类型为select时才使用'
        },
        {
          label: 'input输入2',
          type: 'input',
          decoratorKey: 'name2',
          required: true, // 是否必填
          rules: [{ required: true, message: '不能为空' }], // 表单的校验规则
          colSpan: 1,
          selectOptions: '下拉选项，当且仅当表单类型为select时才使用'
        },
        {
          label: 'select输入',
          type: 'select',
          decoratorKey: 'sex',
          required: true, // 是否必填
          rules: [{ required: true, message: '不能为空' }], // 表单的校验规则

          selectOptions: [
            { value: 0, label: '男' },
            { value: 1, label: '女' }
          ]
        },
        //          {
        //            label:'textarea输入',
        //            type:'textarea',
        //            decoratorKey:'text',
        //            required:true, // 是否必填
        //            rules:[{required: true,message: '不能为空'}],// 表单的校验规则
        //
        //            selectOptions:[
        //              {value:0,label:'男'},
        //              {value:1,label:'女'},
        //            ]
        //          },
        {
          label: 'datepicker输入',
          type: 'datepicker',
          decoratorKey: 'date',
          required: true, // 是否必填
          rules: [{ required: true, message: '不能为空' }], // 表单的校验规则

          selectOptions: '下拉选项，当且仅当表单类型为select时才使用'
        },
        {
          label: 'datepickerRange输入',
          type: 'datepickerRange',
          decoratorKey: 'range',
          required: true, // 是否必填
          rules: [{ required: true, message: '不能为空' }], // 表单的校验规则
          colSpan: 2,
          selectOptions: '下拉选项，当且仅当表单类型为select时才使用'
        }
      ];

      // debug 去除label
      //        config.forEach(item=>item.label=undefined);
      this.formItemConfig = config;
      return this.formItemConfig;
    },

    /**
     * 显示隐藏弹窗
     * @param bol
     * @param titleName 弹窗标题名
     */
    show(bol, titleName) {
      this.visible = bol;
      if (!bol) return this.form.resetFields();

      this.titleName = titleName || '提示';
    },

    /**
     * 设置当前data字段
     */
    setData(key, val) {
      this[key] = val;
    },

    /**
     * 设置表单的值
     */
    setFieldsValue(keyValHash) {
      keyValHash = keyValHash || {};
      this.form.setFieldsValue(keyValHash);
    },

    /**
     * 获取弹窗内的字段值
     */
    getVals() {
      return this.form.getFieldsValue();
    },

    /**
     * 校验表单
     * @return {Promise}
     */
    async valid() {
      return new Promise(resolve => {
        this.form.validateFields(async (err, values) => {
          if (err) resolve(err);
          resolve(null);
        });
      });
    }
  }
};
</script>
